import React from 'react'
import PropTypes from "prop-types"
import { Modal } from 'react-bootstrap'

import Button from '../../components/Button.jsx'

const FormatHelpModal = ({ isAllDay, onClose }) => (
  <Modal show onHide={onClose}>
    <Modal.Body>
      <p>Por favor indica los turnos disponibles en formato HH:MM.</p>
      <p>Ejemplo:</p>
      <div style={{ border: "1px solid darkgrey", width: 80 }}>
        {isAllDay 
          ? (
            <React.Fragment>
              <p style={{ margin: 0 }}>10:00-14:30</p>
              <p style={{ margin: 0 }}>17:30-23:00</p>
            </React.Fragment>
          )
          : (
            <React.Fragment>
              <p style={{ margin: 0 }}>13:00</p>
              <p style={{ margin: 0 }}>13:30</p>
              <p style={{ margin: 0 }}>14:00</p>
            </React.Fragment>
          )
        }
          
      </div>
    </Modal.Body>
    <Modal.Footer>
      <Button onClick={onClose} label="Cerrar" />
    </Modal.Footer>
  </Modal>
)

FormatHelpModal.propTypes = {
  isAllDay: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
}

export default FormatHelpModal